import { Routes, Route, Navigate } from 'react-router-dom'

import ProductionListView from 'Presentation/Views/General/Production/List/View'
import ProductionGroupView from 'Presentation/Views/General/Production/GroupSelection/View'
import ItemSelectionView from 'Presentation/Views/General/Production/ItemSelection/View'
import SustainabilityView from 'Presentation/Views/General/Sustainability/View'
import CertificationView from 'Presentation/Views/General/Certification/View'

const GeneralRoutes = () => (
	<Routes>
		<Route path="/production" element={<ProductionListView />} />

		{/* Route: Product Line Selection */}
		<Route path="/production/product-lines" element={<ProductionGroupView />} />
		{/* Route: Product Line Selection */}

		{/* Route: Product Category Selection */}
		<Route path="/production/:id" element={<ProductionGroupView />} />
		{/* Route: Product Category Selection */}

		{/* Route: Product Category Selection */}
		<Route path="/production/:id/properties" element={<ItemSelectionView />} />
		{/* Route: Product Category Selection */}

		{/* Route: Sustainability */}
		<Route path="/sustainability" element={<SustainabilityView />} />
		{/* Route: Sustainability */}

		{/* Route: Certification */}
		<Route path="/certification" element={<CertificationView />} />
		{/* Route: Certification */}

		{/* Route: Default */}
		<Route path="*" element={<Navigate to="/general/production" />} />
		{/* Route: Default */}
	</Routes>
)

export default GeneralRoutes
